import * as _ from "lodash"

// A helper function to simplify creating effects
const generalEffectAction = (dataObj, attr, effect) => {
  const originalValue = attr ? _.get(dataObj, attr) : dataObj
  const newValue = effect(originalValue)
  if (attr) {
    newValue && _.set(dataObj, attr, newValue)
  }
}

// Scales the amount found at attr by scaleAmount
export const scaleAction = (dataObj, { attr, scaleAmount }) => {
  generalEffectAction(
    dataObj,
    attr,
    originalValue => originalValue && originalValue * scaleAmount
  )
}

// Replaces the values found at attr with newValue
export const replaceAction = (dataObj, { attr, newValue }) => {
  generalEffectAction(dataObj, attr, () => newValue)
}

// Adds amount to the values found at attr
export const additionAction = (dataObj, { attr, amount }) => {
  generalEffectAction(
    dataObj,
    attr,
    originalValue => originalValue && originalValue + amount
  )
}

// Add an item to an array
export const addItemToArrayAction = (dataObj, { attr, newItem }) => {
  generalEffectAction(
    dataObj,
    attr,
    originalArray => originalArray && originalArray.push(newItem)
  )
}

// Remove an item from an array based on a filter condition
export const removeItemFromArrayAction = (dataObj, { attr, filter }) => {
  generalEffectAction(dataObj, attr, originalArray => {
    return originalArray && originalArray.filter(filter)
  })
}

// Remove a key from an object
export const removeKeyFromObjectAction = (dataObj, { attr, keyToDelete }) => {
  generalEffectAction(dataObj, attr, originalObject => {
    //Hack to allow the removal of extra plans in speedTier
    if (originalObject === undefined || originalObject === null) {
      return originalObject
    }
    delete originalObject[keyToDelete]
    return originalObject
  })
}

// Change an item from an array - using a filter function to get the item, and then the amount to add to it?
export const changeItemFromArrayAction = (
  dataObj,
  { attr, filter, change }
) => {
  // Run through general effect, going through the array, and if the filter fires, then run the change function
  generalEffectAction(dataObj, attr, originalArray =>
    originalArray.map(item => (filter(item) ? change(item) : item))
  )
}

// A fixed version of toFixed
// Raises the num by 10^precision, rounds then lowers it back to the original version
const toFixed = (num, precision) =>
  (+(Math.round(+(num + "e" + precision)) + "e" + -precision)).toFixed(
    precision
  )

// Converts an attribute to X dp
export const toXDpAction = (dataObj, { attr, precision, asString = false }) => {
  generalEffectAction(dataObj, attr, originalValue => {
    const newValue = toFixed(originalValue, precision)
    return asString ? newValue : +newValue
  })
}

// Deletes the object found at dataObj[attr][attrToDelete]
export const deleteObjectAction = (dataObj, { attr = "", attrToDelete }) => {
  const parentObj = _.get(dataObj, attr, dataObj)
  _.unset(parentObj, attrToDelete)
}

// The rounding functions!
// Round the value up to the next highest 99 pence
export const to99PenceAction = (dataObj, { attr = "" }) =>
  generalEffectAction(
    dataObj,
    attr,
    originalValue => Math.ceil(originalValue) - 0.01
  )

// Round the value up to the nearest 50 pence interval
export const to50PenceAction = (dataObj, { attr = "" }) =>
  generalEffectAction(
    dataObj,
    attr,
    originalValue => Math.ceil(originalValue * 2) / 2
  )

// Round the value up to the nearest boundary of 0.49 or 0.99
export const to49Or99PenceAction = (dataObj, { attr = "" }) =>
  generalEffectAction(
    dataObj,
    attr,
    originalValue => Math.ceil(originalValue * 2) / 2 - 0.01
  )

export const printAction = dataObj => {
  generalEffectAction(dataObj, null, obj => {
    return obj
  })
}

export default {
  toXDp: toXDpAction,
  scale: scaleAction,
  replace: replaceAction,
  deleteObj: deleteObjectAction
}
